import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Language } from '../../i18n/translations';
export function LanguageToggle() {
  const {
    lang,
    setLang
  } = useLanguage();
  const options: {
    value: Language;
    label: string;
  }[] = [{
    value: 'es',
    label: 'ES'
  }, {
    value: 'en',
    label: 'EN'
  }];
  return <div role="group" aria-label="Language selector" className="relative flex items-center p-1 bg-white/70 backdrop-blur-sm border border-brand-dark/10 rounded-full" data-id="element-389" data-mp="32mwwrwk4839u">
      {options.map(opt => {
      const isActive = lang === opt.value;
      return <button key={opt.value} onClick={() => setLang(opt.value)} aria-pressed={isActive} className={`relative z-10 px-4 py-1.5 text-xs font-semibold tracking-wider transition-colors rounded-full ${isActive ? 'text-white' : 'text-brand-dark/60 hover:text-brand-dark'}`} data-id="element-390" data-mp="3cet4lzc077r9">
            {opt.label}
            {isActive && <span aria-hidden="true" className="absolute inset-0 -z-10 bg-brand-accent rounded-full" data-id="element-391" data-mp="3m4tlagk2rwkn" />}
          </button>;
    })}
    </div>;
}